import { Card } from '@/app/common/components/Card'
import { Award } from 'lucide-react'
import type { Purse } from '@/queries/program_purses/schemas.ts'
import { ScholarshipAwardCard } from './scholarship-award-card'

type Props = {
  purses: Purse[]
  programId: number
}

export default function ScholarshipAwarding(props: Props) {
  const { purses, programId } = props

  if (purses.length === 0) {
    return (
      <Card className="max-w-md mx-auto mt-10">
        <div className="text-center py-12 px-6">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-gray-100 flex items-center justify-center">
            <Award />
          </div>

          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            No purses available
          </h3>

          <p className="text-gray-600 leading-relaxed">
            Awarded students can be funded once you create a purse. Start by
            setting up your first purse.
          </p>
        </div>
      </Card>
    )
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10 max-w-5xl mx-auto">
      {purses.map((purse) => (
        <ScholarshipAwardCard
          key={purse.id + purse.name}
          purse={purse}
          programId={programId}
        />
      ))}
    </div>
  )
}
